import mapbox from 'mapbox-gl';

// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken = 'pk.eyJ1IjoianVsaXNhZ2VydCIsImEiOiJja2FudG42emUxZHI2MnhvNnpmczFkNngwIn0.tiEAXkrCtoHFBI3wJ5A4zg';

const key = {};

export { mapbox, key };